import Base from './base'
import { format } from 'date-fns'
import { capitalize } from '../util'
import activityFactory from '../activity_factory.js'
import URI from 'urijs'

export default class Response extends Base {
  initialize () {
    return super.initialize(...arguments)
  }

  urlRoot () {
    return URI('/api/participants').segment(this.id.toString()).segment('responses').toString()
  }

  submissionDate () {
    return format(new Date(this.get('created_at')), 'MM/dd/yyyy')
  }

  submissionTime () {
    return format(new Date(this.get('created_at')), 'h:mm:ssa')
  }

  poll () {
    return this.get('poll')
  }

  pollTitle () {
    return this.poll().get('title')
  }

  pollLink () {
    return this.poll()._urlBase()
  }

  pollOwnerName () {
    const ownerName = this.poll().get('owner_name')

    return ownerName.split(' ').map(item => capitalize(item)).join(' ')
  }

  pollOwnerEmail () {
    return this.poll().get('owner_email')
  }

  response () {
    return this.get('humanized_value')
  }

  parse (attrs) {
    /*
     * TODO come up with a convention for
     * parsing out associations from our api
     */
    attrs.poll = activityFactory(attrs.poll)

    return super.parse(...arguments)
  }
}
